/** Priority order for dashboard glance stats — first = kept longest when space is tight. */
export const GLANCE_STAT_ORDER = [
  'totalHours',
  'totalTasks',
  'activeDays',
  'bestDay',
  'delta',
  'biggestTask',
];

/** Max glance stats visible per breakpoint (controlled drop). */
export const MAX_GLANCE_STATS_BY_BREAKPOINT = {
  xs: 2,
  s: 3,
  m: 4,
  l: 5,
  xl: 6,
};

/**
 * Selects which glance stats to show for the current viewport width.
 * @param {Record<string, boolean>} availability — stat id → should render when space allows
 * @param {string} breakpoint
 * @returns {string[]} stat ids to display, highest priority first
 */
export const selectGlanceStatIds = (availability, breakpoint) => {
  const maxVisible =
    MAX_GLANCE_STATS_BY_BREAKPOINT[breakpoint] ??
    MAX_GLANCE_STATS_BY_BREAKPOINT.m;

  return GLANCE_STAT_ORDER.filter((id) => availability[id]).slice(
    0,
    maxVisible,
  );
};
